import { JetsonHealthDTO } from '../../types';
import { getDataWithRetry } from '../fetchUtils';
import { apiBaseUrl } from '../apiConsts';
import { isValidJetsonsHealthResponse } from '../apiValidators';

import type { FetchResult } from '../fetchUtils';
import type { PagedResponse } from '../../types';

export const getJetsonsHealthByGymId = async (
  gymId: string,
): Promise<FetchResult<JetsonHealthDTO[]>> => {
  const response = await getDataWithRetry<
    JetsonHealthDTO[] | PagedResponse<JetsonHealthDTO>
  >(
    `${apiBaseUrl}jetson-manager/health/${gymId}`,
    {},
    isValidJetsonsHealthResponse,
  );
  if (!response.success) {
    return response;
  }
  const normalizedData = Array.isArray(response.data)
    ? response.data
    : response.data?.content ?? [];
  return {
    ...response,
    data: normalizedData,
  };
};
